import { createSelector, Dispatch } from '@reduxjs/toolkit';
import { Pagination } from 'gql/autogen/Pagination';
import { selectIsEmptyActivitiesAfterFiltered, selectResultInfoFromSearchState } from 'component/page/search/store/search.selectors';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { fetchActivities } from 'component/page/search/store/search';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { getPaginationQueryString } from 'component/page/search/Pagination/pagination.utils';
import { setLocationSearch } from 'store/slice/navigation';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ElementEventIds } from '@agoda/analytics-messages-definition-activities';
import {
    ActivitiesPaginationNextBtnClickEventActivitiesFieldsV7,
    ActivitiesPaginationPrevBtnClickEventActivitiesFieldsV7,
} from '@agoda/analytics-messages-definition-activities/events.split';

interface StateProps {
    cms: CmsValue;
    page: Pagination;
    totalActivities: number;
    forceNavigateToFirstPage: boolean;
}

interface DispatchProps {
    trackPaginationChange: (eventIds: ElementEventIds, pageNumber: number) => void;
    handleForceNavigateToFirstPage: (locationSearch: string, pageNumber: number, pageSize: number) => void;
}

export type Props = StateProps & DispatchProps;

type PaginationBtnEventFields = ActivitiesPaginationNextBtnClickEventActivitiesFieldsV7 | ActivitiesPaginationPrevBtnClickEventActivitiesFieldsV7;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectResultInfoFromSearchState,
    selectIsEmptyActivitiesAfterFiltered,
    (cms, resultInfo, forceNavigateToFirstPage): StateProps => {
        return {
            cms,
            forceNavigateToFirstPage,
            page: resultInfo.pagination,
            totalActivities: resultInfo.totalFilteredActivities,
        };
    },
);

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    trackPaginationChange: (eventIds: ElementEventIds, pageNumber: number) => {
        trackElementEvent<PaginationBtnEventFields>(eventIds, { page_number: pageNumber });
    },
    handleForceNavigateToFirstPage: (locationSearch: string, pageNumber: number, pageSize: number) => {
        const query = getPaginationQueryString(locationSearch, pageNumber, pageSize);
        dispatch(setLocationSearch({ query }));
        fetchActivities();
    },
});
